(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceHeaderDialogController', InvoiceHeaderDialogController);

    InvoiceHeaderDialogController.$inject = ['$timeout', '$scope',  '$uibModalInstance', '$q', 'entity', 'InvoiceHeader', 'Document'];

    function InvoiceHeaderDialogController ($timeout, $scope,  $uibModalInstance, $q, entity, InvoiceHeader, Document) {
        var vm = this;

        vm.invoiceHeader = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.documents = Document.query({filter: 'invoiceheader-is-null'});
        $q.all([vm.invoiceHeader.$promise, vm.documents.$promise]).then(function() {
            if (!vm.invoiceHeader.documentId) {
                return $q.reject();
            }
            return Document.get({id : vm.invoiceHeader.documentId}).$promise;
        }).then(function(document) {
            vm.documents.push(document);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (angular.isDefined(vm.invoiceHeader.id) && vm.invoiceHeader.id !== null) {
                InvoiceHeader.update(vm.invoiceHeader, onSaveSuccess, onSaveError);
            } else {
                InvoiceHeader.save(vm.invoiceHeader, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('eDocumentsApp:invoiceHeaderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.salesOrderDate = false;
        vm.datePickerOpenStatus.invoiceExpirationDate = false;
        vm.datePickerOpenStatus.dueDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
